import { createContext } from 'react';
var AuthenticationContext = /*#__PURE__*/createContext({
  auth0Api: undefined,
  handleAdfsConnection: function () {},
  handleAuthentication: function () {},
  idToken: undefined,
  isAuthenticated: false,
  loading: true,
  login: function () {},
  logout: function () {},
  renewSession: function () {},
  user: undefined
});
export default AuthenticationContext;